import { render } from "./PopupSlides.vue?vue&type=template&id=3a431d03&scoped=true&ts=true"
import script from "./PopupSlides.vue?vue&type=script&lang=ts"
export * from "./PopupSlides.vue?vue&type=script&lang=ts"

import "./PopupSlides.vue?vue&type=style&index=0&id=3a431d03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a431d03"]])

export default __exports__